<template>
  <div>
    <div v-if="show" class="sidemenu-mask-dropdown-list carrier" :level="level" :open="true">
      <div class="sidemenu-mask-dropdown" @click="isOpen = !isOpen" :id="item.code" :data-children="childCount" :ref="item.code">
        <div class="tooltip-hover" :title="item.name">
          <i :class="['status-icon fa fa-chevron-right', isOpen ? 'open' : '']"></i>
          <i v-if="!isOpen" class="fa fa-folder"></i>
          <i v-if="isOpen" class="fa fa-folder-open"></i>
          {{ item.name }}
        </div>
      </div>

      <div class="sidemenu-mask-dropdown-list" :data-controlled-by="item.code" :open="isOpen || undefined" :level="getNextLevel()" :type="item.code" :ref="item.code">
        <div v-for="child in templates" :key="child.id">
          <MenuItem
            v-bind:item="child"
            :activeSite="activeSite"
            :activeUser="activeUser"
            :reportTypeCodes="reportTypeCodes"
            :level="getNextLevel()"
            :carriers="carriers"
            :open="isOpen || undefined"
            :reportCodeCounts="reportCodeCounts"
            :carrierCode="child.carrierCode"
            @years="onYearsEvent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import _ from 'underscore'
import MenuItem from '../MenuItem.vue'

const props = defineProps({
  item: Object,
  level: Number,
  reportCodeCounts: Object,
  reportTypeCodes: Array,
  carriers: Array,
  activeSite: Object,
  activeUser: Object,
})

const isOpen = ref(false)
const childCount = ref(0)
const show = ref(true)
const templates = ref([])

watch(
  () => childCount.value,
  (count) => {
    if (count < 1) {
      // if no children
      show.value = false
      emit('is-invalid')
    }
  }
)

onMounted(() => {
  let templatesCopy = _.map(props.item.template, _.clone)
  const flattenedReportTypeCodes = props.reportCodeCounts
    ? props.reportCodeCounts.carriers.map((reportType) => {
        if (reportType.carrierCode === props.item.code) {
          return reportType.typeCode
        }
      })
    : []

  templates.value = templatesCopy
    .map((template) => {
      delete template.templates
      return template
    })
    .filter((template) => {
      let hasAtleastOne = false

      template.children.forEach((child) => {
        if (flattenedReportTypeCodes.includes(child.code)) {
          hasAtleastOne = true
        }
      })

      return hasAtleastOne
    })

  childCount.value = templates.value.length

  templates.value.forEach(function (_child) {
    _child.level++
    _child.isCarrier = true
    appendIsDocument(_child)
  })

  let carrierCodes = props.reportCodeCounts.carriers.filter(function (_code) {
    if (_code.carrierCode === props.item.code) {
      return _code
    }
  })

  if (carrierCodes.length < 1) {
    emit('is-invalid')
    show.value = false
  }
})

const getNextLevel = () => {
  return props.level + 1
}

const onYearsEvent = (data) => {
  Object.keys(data).forEach(function (key, value) {
    if (years.value[key]) {
      years.value[key] = [...years.value[key], ...data[key]]
    } else {
      years.value[key] = data[key]
    }
  })
}

const appendIsDocument = (child) => {
  child.isDocument = true
  child.level++
  child.carrierCode = props.item.code
  child.carrierCodes = [props.item.code]
  child.children = _.map(child.children, _.clone)
  child.isCarrier = true

  if (child.children.length > 0) {
    child.children.forEach(function (_child) {
      appendIsDocument(_child)
    })
  }
}
</script>
